<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">{{
          $t('administration.personneMorale.personneMorale.list.title')
        }}</v-list-item-title>
        <v-list-item-subtitle>{{
          $t('administration.personneMorale.personneMorale.list.sub')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="6">
          <search-by
            :datasource="ds"
            attr="personneMorale"
            i18n="administration.personneMorale.personneMorale.list.search.personneMorale"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <search-by
            :datasource="ds"
            attr="division"
            i18n="administration.personneMorale.personneMorale.list.search.division"
          />
        </v-col>
      </v-row>
      <datasource-table :datasource="ds">
        <template #item.raisonSociale="{item}">
          <navigable-link
            :to="{
              name: 'administration/personneMorale/personneMorale-detail',
              params: { id: item.id },
            }"
          >
            {{ item.raisonSociale }}
          </navigable-link>
        </template>
        <template #item.nomUsuel="{item}">
          <navigable-link
            :to="{
              name: 'administration/personneMorale/personneMorale-detail',
              params: { id: item.id },
            }"
          >
            {{ item.nomUsuel }}
          </navigable-link>
        </template>
        <template #item.divisions="{item}">
          <navigable-link
            :to="{
              name: 'administration/personneMorale/personneMorale-detail',
              params: { id: item.id },
            }"
          >
            {{ item.divisions.map(d => d.libelle).join(', ') }}
          </navigable-link>
        </template>
      </datasource-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';

export default {
  mounted() {
    this.ds.refresh();
  },
  props: {
    /** Titre de la page */
    title: {
      type: String,
      default: null,
    },
    /** Les infos pour le retour vers le menu paramétrage */
    returnRoute: {},
  },
  data() {
    const ds = new Datasource('administration/personne-morale/list', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nomUsuel'],
      descending: false,
      labelNamespace: 'administration.personneMorale.personneMorale.list.table',
      args: {},
      fields: [
        {
          value: 'nomUsuel',
          sortable: true,
        },
        {
          value: 'raisonSociale',
          sortable: true,
        },
        {
          value: 'divisions',
          sortable: false,
        },
      ],
    });

    return {
      ds,
    };
  },
  methods: {},
};
</script>
